// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.au-sidebar {
  width: var(--admin-sidebar-w);
  min-width: 0;
  padding: var(--admin-s5) var(--admin-s4);
  border-right: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(255, 255, 255, 0.015);
  box-sizing: border-box;
}

@media (max-width: 960px) {
  .au-sidebar {
    width: 100%;
    border-right: 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Admin/ui/AdminSidebar.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,YAAY;EACZ,wCAAwC;EACxC,iDAAiD;EACjD,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,kDAAkD;EACpD;AACF","sourcesContent":[".au-sidebar {\n  width: var(--admin-sidebar-w);\n  min-width: 0;\n  padding: var(--admin-s5) var(--admin-s4);\n  border-right: 1px solid rgba(255, 255, 255, 0.06);\n  background: rgba(255, 255, 255, 0.015);\n  box-sizing: border-box;\n}\n\n@media (max-width: 960px) {\n  .au-sidebar {\n    width: 100%;\n    border-right: 0;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
